// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wszz7","index":"styles_index__2GBIw"};